const $ = window.jQuery;

export default class EventPages {
  constructor() {
    this.secondsOnPage = 0;
    this.totalSecondsRemaining = 0;
    this.daysRemaining = 0;
    this.hoursRemaining = 0;
    this.minutesRemaining = 0;
    this.secondsRemaining = 0;
    this.event_booking_dialog = document.getElementById("event_booking_overlay");
  }

  init() {
    this.eventCountdown();
    this.eventBookingModal();
  }

  eventCountdown() {
    const countdown = $('#countdown_clock');
    let daysRemainingSec = 0;
    let hoursRemainingSec = 0;
    let minutesRemainingSec = 0;

    if (countdown && countdown.length) {

      const nowInSeconds = Math.floor(Date.now() / 1000);
      const startsInSeconds = countdown.data('start_time');

      setInterval(() => {

        this.secondsOnPage += 1;
        this.totalSecondsRemaining = startsInSeconds - nowInSeconds - this.secondsOnPage;

        if (this.totalSecondsRemaining > 0) {

          this.daysRemaining = Math.floor( this.totalSecondsRemaining / 60 / 60 / 24 );

          daysRemainingSec = this.daysRemaining * 24 * 60 * 60;
          this.hoursRemaining = Math.floor( (this.totalSecondsRemaining - daysRemainingSec) / 60 / 60 );

          hoursRemainingSec = this.hoursRemaining * 60 * 60;
          this.minutesRemaining = Math.floor( (this.totalSecondsRemaining - daysRemainingSec  - hoursRemainingSec ) / 60 );

          minutesRemainingSec = this.minutesRemaining * 60;
          this.secondsRemaining = Math.floor( (this.totalSecondsRemaining - daysRemainingSec  - hoursRemainingSec  - minutesRemainingSec) );

          $('#countdown_days .number').removeClass('loading').text(this.daysRemaining);
          $('#countdown_hours .number').removeClass('loading').text(this.hoursRemaining);
          $('#countdown_minutes .number').removeClass('loading').text(this.minutesRemaining);
          $('#countdown_seconds .number').removeClass('loading').text(this.secondsRemaining);

        }
      }, 1000);

    }
  }

  eventBookingModal() {
    $('.open_event_booking').on('click', () => {
      this.event_booking_dialog.showModal();
    });
    $('#close_event_booking_overlay').on('click', () => {
      this.event_booking_dialog.close();
    });
  }
  
}

